import { ChangeEvent, PropsWithChildren, ReactNode, useState } from "react";

import { ClickableTextPanel } from "@/Common/Components/ClickableText/ClickableTextPanel";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { IMessage } from "../InvitationForm";

import styles from "./MessageForm.module.scss";

interface MessageFormProps {
    readonly required?: boolean;
    readonly values?: IMessage;
    readonly onChange?: (value: IMessage) => void;
    readonly subHeading?: ReactNode;
}

function MessageForm(props: PropsWithChildren<MessageFormProps>): JSX.Element {
    const { getText: t } = useTranslation();
    const [isClickableTextBodyOpen, setIsClickableTextBodyOpen] = useState(false);
    const [isClickableTextSubjectOpen, setIsClickableTextSubjectOpen] = useState(false);

    const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>): void => {
        const { value, name } = e.target;

        props.onChange({ ...props.values, [name]: value });
    };

    return (
        <>
            <h4 className={styles.messageFormHeading}>
                {t("PortalInvitation_SendMessageLabel")} {!props.required ? `(${t("OptionalLabel")})` : null}
            </h4>

            {props.children}

            {props.subHeading}

            <form name="message">
                <div className={styles.formGroup}>
                    <label htmlFor="subject">
                        <strong>{t("SubjectLabel")}</strong>
                    </label>
                    <input type="text" id="messageForm-subject" name="subject" className="form-control" onChange={handleChange} />

                    {isClickableTextSubjectOpen && (
                        <div className={styles.messageFormClickableText}>
                            <ClickableTextPanel
                                context="SMESSAGES"
                                cssClass="text-helper-container"
                                inputElementId="messageForm-subject"
                                onCloseEvent={() => setIsClickableTextSubjectOpen(false)}
                                reduceHeight={true}
                            />
                        </div>
                    )}

                    <div className="text-right">
                        <a
                            onClick={() => {
                                setIsClickableTextBodyOpen(false);
                                setIsClickableTextSubjectOpen(true);
                            }}
                        >
                            {t("SelectFromListLabel")}
                        </a>
                    </div>
                </div>

                <div className={styles.formGroup}>
                    <label htmlFor="body">
                        <strong>{t("MessageLabel")}</strong>
                    </label>
                    <textarea id="messageForm-body" name="body" className="form-control" onChange={handleChange} />

                    {isClickableTextBodyOpen && (
                        <div className={styles.messageFormClickableText}>
                            <ClickableTextPanel
                                context="BMESSAGES"
                                cssClass="text-helper-container"
                                inputElementId="messageForm-body"
                                onCloseEvent={() => setIsClickableTextBodyOpen(false)}
                                reduceHeight={true}
                            />
                        </div>
                    )}

                    <div className="text-right">
                        <a
                            onClick={() => {
                                setIsClickableTextBodyOpen(true);
                                setIsClickableTextSubjectOpen(false);
                            }}
                        >
                            {t("SelectFromListLabel")}
                        </a>
                    </div>
                </div>
            </form>
        </>
    );
}

export { MessageForm };
